export const CHANGE_STATUS_TOTAL_STEPS = 2;
